export const SANTECLAIR = 16
export const ITELIS = 22

export const HOSPIWAY = 2297

export const TELECONSULTATION_VYV = 1493

// PolymorphicBlock ne peut correspondre a aucun service.
export const WELII_TCM = 2294
export const WELII_ASS = 2452

/*
 automedication
 owop
 jalonnement
 owih
 nosmoking
 nutriclair
 devisdentaire
 */
export const SERVICES_SANTECLAIR = {
	OWOP: 'owop',
	PU: 'pu'
}
